export default "__VITE_ASSET__DBYn9Se4__"